<img src="/assets/images/file1.svg" *ngIf="imgType === 1" alt="" width="25" height="34" />
<img src="/assets/images/file2.svg" *ngIf="imgType === 2" alt="" width="25" height="34" />
<img src="/assets/images/file3.svg" *ngIf="imgType === 3" alt="" width="25" height="34" />
<img src="/assets/images/file4.svg" *ngIf="imgType === 4" alt="" width="25" height="34" />
<span class="file-type-text">{{ fileTypeText }}</span>
